import {
  Tabs,
  Tab,
  TabPanel,
  Box,
  Button,
  ContentModal,
  Inline,
  Backdrop,
  LoadingLayout,
  Center,
  Text,
} from "@digitalreality/ui";
import { useState, useRef } from "react";
import LayersMap from "./Map";
import License from "./License";
import DailyJobs from "./DailyJobs";
import ConXConnection from "./ConXConnection";
import GeneralDetails from "./General";
import Access from "./Access";
import React from "react";
import { useTranslation } from "react-i18next";
import { useAppState } from "../../StateStore/Store";
import { ProjectFormData } from "../../Models/ProjectFormData";
import {
  addProjectError,
  setProject,
  updateProjectError,
} from "../../StateStore/ProjectModal/ProjectModalActions";
import { createProjectAsync, deleteProjectAsync, updateProjectAsync, sendEmailToLMCSupportAsync } from "../../Services/ProjectsService";
import { RestApiResponse } from "../../Models/RestApiResponse";
import { updateProjectsList } from "../../StateStore/ProjectList/ProjectListActions";
import { ProjectSummary } from "../../Models/ProjectSummary";
import { notAuthorised } from "../../StateStore/UserAuth/UserAuthActions";
import DataProviders from "./DataProviders";
import DataReceivers from "./DataReceivers";
import { redeemLicenseForProjectAsync } from "../../Services/LicensesService";
import { getProjectsList } from "../../StateStore/ProjectList/ProjectListActionMiddleware";
import Divider from '@mui/material/Divider';

const errorImage = require("../../Images/errorImage.png");
const errorImageNoLicense = require("../../Images/errorImageNoLicense.png");

const ClientDetailsModal = function ({
  showModal,
  setOpenModal,
  editMode,
}: any) {
  const { t } = useTranslation();
  const [tabValue, setTabValue] = useState(0);
  const [loading, setLoading] = useState(false);
  const [loadingText, setLoadingText] = useState("");
  const { state, dispatch } = useAppState();
  const submitRef = useRef(null);

  var tempTabValue: number = 0;
  var finalSubmit: boolean = false;

  enum TabName {
    Details = 0,
    Map = 1,
    Access = 2,
    License = 3,
    DailyJobs = 4,
    ConXConnection = 5,
    DataSources = 6,
    DataReceivers = 7
  }

  const handleTabsChange = (event: any, newValue: number) => {
    tempTabValue = newValue;
    handlePartialFormSubmit();
  };

  const handlePartialFormSubmit = () => {
    console.log(submitRef.current);
    if (submitRef.current) {
      (submitRef.current as HTMLFormElement).requestSubmit();
    }
  };

  const handleModalClose = () => {
    setOpenModal(false);
    setTabValue(0);
  };

  const onPartialSubmit = (formData: ProjectFormData) => {
    dispatch(setProject(formData));
    if (finalSubmit) {
      onProjectSubmit(formData);
    } else {
        setTabValue(tempTabValue);
    }
  };

    const onProjectSubmit = (formData: ProjectFormData) => {
        setLoading(true);

        var project = formData; //state.projectModal.project;
        if (project) {
            if (!project.dealerProjectId) {
                setLoadingText(t("Texts.CreateProjectLoadingMessage"));
                createProjectAsync(project.projectName).then(
                    (response: RestApiResponse) => {
                        if (response.statusCode === 401) {
                            dispatch(notAuthorised());
                        }
                        if (response.success) {
                            console.log("new client created:" + response.data.projectId);
                            (project as ProjectFormData).dealerProjectId = response.data.projectId;
                            updateProject(project as ProjectFormData, true);

                            sendEmailToLMCSupportAsync("New project created", "A new project has been created with the name: " + project.projectName + " and the connected ConX Project ID: " + project.conXProjectId + " Dealer Name: " + state.userAuth.user?.firstname + " " + state.userAuth.user?.lastname).then();
                        } else {
                            const errorCode = response.errorCode ? response.errorCode : "ProjectCreateError";
                            dispatch(addProjectError(errorCode));
                            setLoading(false);
                        }
                    }
                );
            } else {
                updateProject(project, false);
            }
        }
    };

    function updateProject(data: ProjectFormData, isNewlyCreated: boolean) {
        setLoadingText(t("Texts.UpdateProjectLoadingMessage"));
        updateProjectAsync(data).then((response: RestApiResponse) => {
            if (response.statusCode === 401) {
                dispatch(notAuthorised());
            }
            if (response.success) {
                console.log("project updated");
                const project: ProjectSummary = {
                    id: data.dealerProjectId as number,
                    timezoneOffset: data.timeZone,
                    name: data.projectName,
                    country: data.country,
                    logo: data.logo && data.logo.data ? data.logo.data : undefined,
                    customer: data.customer,
                };
                if (isNewlyCreated) {
                    addLicense(data.projectName, data.licenseKey as string);
                } else {
                dispatch(updateProjectsList(project));
                setLoading(false);
                handleModalClose();
            }
        } else {
            if (isNewlyCreated) {
                deleteProjectAsync(data.projectName).then((response: RestApiResponse) => {
                    if (response.success) {
                        const errorCode = "ProjectCreateUpdateError";
                        dispatch(updateProjectError(errorCode));
                    } else {
                        const errorCode = response.errorCode ? response.errorCode : "ProjectDeleteError";
                        dispatch(updateProjectError(errorCode));
                    }
                    setLoading(false);
                });
            } else {
                const errorCode = response.errorCode ? response.errorCode : "ProjectUpdateError";
                dispatch(updateProjectError(errorCode));
                setLoading(false);
            }
        }
        });
    }

    function addLicense(projectName: string, licenseKey: string) {
        setLoadingText(t("Texts.UpdateLicenseLoadingMessage"));
        redeemLicenseForProjectAsync(projectName, licenseKey).then((response: RestApiResponse) => {
            if (response.statusCode === 401) {
                dispatch(notAuthorised());
            }
            if (response.success) {
                getProjectsList(state.projectList.filter)(dispatch);
                setLoading(false);
                handleModalClose();
            } else {
                const errorCode = response.errorCode ? response.errorCode : "ProjectCreateAddLicenseError";
                dispatch(updateProjectError(errorCode));
                setLoading(false);
            }
        });
    }

  const modalLoading = (
    <Backdrop open={true} sx={{ zIndex: 1 }}>
      {" "}
      <LoadingLayout text={loadingText} />{" "}
    </Backdrop>
  );

  const modalError = (
    <Box display="flex" justifyContent="center" alignItems="center" sx={{ paddingTop: "26px", height: "700px" }}>
      <Center>
      <Text variant="title" sx={{padding: 2}}>
          {state.projectModal.errorCode
            ? t("Texts." + state.projectModal.errorCode)
            : ""}
        </Text>
        <Text variant="body1" sx={{padding: 5}}> {state.projectModal.errorCode == "ProjectCreateAddLicenseError" ? t("Project was created, but a valid license could not be successfuly added. Please add a valid license at a later time.") : t("An unexpected error occurred while preparing the database and your request couldn't be finalized")} </Text>
        <Box component="img" src={state.projectModal.errorCode == "ProjectCreateAddLicenseError" ? errorImageNoLicense : errorImage} alt="Error" sx={{ width: '600px', height: 'auto', maxWidth: '100%'}}/>
      </Center>
    </Box>
  );

    const modalContent = (
        <Box sx={{ paddingTop: "26px", height: "700px" }}>
            <Tabs
                sx={{ width: "800px", mx: 'auto', justifyContent: 'center' }}
                value={tabValue}
                onChange={handleTabsChange}
                centered={true}
                indicatorColor="secondary">
                <Tab sx={{ textAlign: 'center' }} disabled={!editMode && tabValue !== TabName.Details} value={TabName.Details} label={t("Texts.Details")}/>
                <Tab disabled={!editMode && tabValue !== TabName.Map} value={TabName.Map} label={t("Texts.Map")}/>
                <Tab disabled={!editMode && tabValue !== TabName.Access} value={TabName.Access} label={t("Texts.Access")}/>
                <Tab disabled={!editMode && tabValue !== TabName.License} value={TabName.License} label={t("Texts.License")}/>
                <Tab disabled={!editMode && tabValue !== TabName.DailyJobs} value={TabName.DailyJobs} label={t("Daily Jobs")}/>
                {!editMode && (<Tab disabled={!editMode && tabValue !== TabName.ConXConnection} value={TabName.ConXConnection} label={t("ConX Connection")}/>)}
                {editMode && (<Tab disabled={!editMode && tabValue !== TabName.DataSources} value={TabName.DataSources} label={t("Data sources")}/>)}
                {editMode && (<Tab disabled={!editMode && tabValue !== TabName.DataReceivers} value={TabName.DataReceivers} label={t("Data receivers")}/>)}
            </Tabs>
            <Box sx={{ mx: 'auto', left: "-10px", position: "relative", width: "781px", borderBottom: 1, borderColor: 'divider' }}></Box>
            <TabPanel value={tabValue} index={TabName.Details} paddingTop="32px">
                <GeneralDetails
                    onSubmit={onPartialSubmit}
                    formRef={submitRef}>
                </GeneralDetails>
            </TabPanel>
            <TabPanel value={tabValue} index={TabName.Map} paddingTop="32px">
                <LayersMap onSubmit={onPartialSubmit} formRef={submitRef} />
            </TabPanel>
            <TabPanel value={tabValue} index={TabName.Access} paddingTop="32px">
                <Access onSubmit={onPartialSubmit} formRef={submitRef}></Access>
            </TabPanel>
            <TabPanel value={tabValue} index={TabName.License} paddingTop="32px">
                <License
                    onSubmit={onPartialSubmit}
                    formRef={submitRef}
                    editMode={editMode}/>
            </TabPanel>
            <TabPanel value={tabValue} index={TabName.DailyJobs} paddingTop="32px">
                <DailyJobs
                    onSubmit={onPartialSubmit}
                    formRef={submitRef}
                    editMode={editMode}/>
            </TabPanel>
            {!editMode && (
            <TabPanel value={tabValue} index={TabName.ConXConnection} paddingTop="32px">
                <ConXConnection
                    onSubmit={onPartialSubmit}
                    formRef={submitRef}/>
            </TabPanel>
            )}
            {editMode && (
            <TabPanel value={tabValue} index={TabName.DataSources} paddingTop="32px">
                <DataProviders onSubmit={onPartialSubmit} formRef={submitRef} />
            </TabPanel>
            )}
            {editMode && (
            <TabPanel value={tabValue} index={TabName.DataReceivers} paddingTop="32px">
                <DataReceivers onSubmit={onPartialSubmit} formRef={submitRef} />
            </TabPanel>
            )}
        {}
    </Box>
  );
    return (
        <ContentModal
            variant="solid"
            title={editMode ? t("Texts.Edit") + " " + state.projectModal.project?.projectName : t("Texts.CreateProject")}
            size="extraLarge"
            ModalActionsProps={{sx: {padding: "16px 16px 16px 16px" }}}
            ModalContentProps={{sx: {padding: "0px 24px 0px 24px" }}}
            ModalProps={{PaperProps: {sx: {maxWidth: "1340px", width: "1340px"}}}}
            open={showModal}
            onClose={handleModalClose}
            footerContent={
                <Inline justifyContent="flex-end" gap={3}>
                    {(tabValue > 0 && !editMode) && !state.projectModal.errorCode && (
                        <Button
                            variant="outlined"
                            onClick={(event) => {
                                finalSubmit = false;
                                handleTabsChange(event, tabValue - 1);
                            }}>
                        {t("Texts.Previous")}
                        </Button>
                    )}
                    {tabValue !== 5 && !editMode && !state.projectModal.errorCode && (
                        <Button
                            variant="outlined"
                            onClick={(event) => {
                                finalSubmit = false;
                                handleTabsChange(event, tabValue + 1);
                            }}>
                        {t("Texts.Continue")}
                    </Button>
                    )}
                    {((tabValue === 5 || editMode) && !state.projectModal.errorCode) && (
                        <Button
                        variant="accent"
                        onClick={(event) => {
                            finalSubmit = true;
                            handlePartialFormSubmit();
                        }}
                        >
                        {t("Texts.Submit")}
                        </Button>
                    )}
                    <Button onClick={handleModalClose} variant="outlined">{state.projectModal.errorCode ? t("Ok") : t("Texts.Cancel")}</Button>
                </Inline>
            }>
            <Divider />
            {state.projectModal.loaded
                ? state.projectModal.errorCode
                ? modalError
                : modalContent
                : modalLoading}
            {loading ? modalLoading : ""}
            <Divider />
        </ContentModal>
    );
};
export default ClientDetailsModal;
